export default "__VITE_ASSET__6684523a__"